<template lang="pug">
  div
    b-row
      //- .col-xl-4
      //-   panel(:title='$t("ui.profile")')
      //-     Profile
      .col-xl-4
        panel(:title='$t("ui.password")')
          ChangePassword
      .col-xl-4
        panel(:title='$t("ui.security_code")')
          SecurityCode
</template>

<script>
// import Profile from "@/components/settings/profile";
import ChangePassword from "@/components/settings/changePassword";
import SecurityCode from "@/components/settings/securityCode";

export default {
  components: {
    // Profile,
    ChangePassword,
    SecurityCode
  }
}
</script>